import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ApiCredentialStatus } from 'src/app/pages/api-credential/api-credential.component';
import { GridSwitchCellComponent } from './grid-switch-cell.component';

@Component({
  selector: 'app-grid-switch-renderer',
  standalone: true,
  imports: [GridSwitchCellComponent],
  template: `
    <app-grid-switch-cell
      [checked]="value"
      [disabled]="disabled"
      (checkedChange)="onToggle($event)">
    </app-grid-switch-cell>
  `
})
export class GridSwitchRendererComponent implements ICellRendererAngularComp {
  params: any;
  value = false;
  disabled = false;

  agInit(params: any): void {
    this.params = params;
    this.value = typeof params.value === 'string' ? params.value === ApiCredentialStatus.ACTIVE : !!params.value;
  }

  refresh(params: any): boolean {
    this.params = params;
    this.value = typeof params.value === 'string' ? params.value === ApiCredentialStatus.ACTIVE : !!params.value;
    return true;
  }

  onToggle(newValue: boolean): void {
    this.value = newValue;
    const newStatus = newValue ? 'ACTIVE' : 'INACTIVE';
    this.params.node.setDataValue(this.params.colDef.field, newStatus);

    if (this.params.context?.componentParent?.onStatusToggle) {
      this.params.context.componentParent.onStatusToggle(this.params.data, newValue);
    }
  }
}